import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Suspense } from 'react';
import { Image } from '@/components/client';
import { BenefitsBanner } from './BenefitsBanner';
interface MainInfoSectionProps {
  title: string;
  summary: string;
  description: string;
  institutionId: number;
  backgroundVideoImageUrl: string;
  pcBackgroundVideoImageUrl?: string;
  logoUrl: string;
  //* 카뱅 시안은 로고·지역명을 히어로 위에 얹고 이미지 아래 기관 정보 블록을 두지 않는다.
  isKakaobank: boolean;
}
const DUMMY_HERO_IMAGE_URL = 'https://cdn.welfarehello.com/static/institution-hero-common.png';
export const MainInfoSection = t0 => {
  const $ = _c(48);
  const {
    title,
    summary,
    description,
    institutionId,
    backgroundVideoImageUrl,
    pcBackgroundVideoImageUrl,
    logoUrl,
    isKakaobank
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("absolute z-[1] size-full", "mobile-tablet:hidden");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== logoUrl || $[2] !== title) {
    t2 = <Image src={logoUrl} alt={title} width={48} height={48} className="rounded-pill" />;
    $[1] = logoUrl;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h1 className="font-800 text-Gray-white typo-h4">{title}</h1>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="shrink-0 basis-[360px] flex-col gap-20 flex-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-100 border-l-1 border-Gray-white/60" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== summary) {
    t6 = <p className="whitespace-pre-line break-keep text-left font-700 text-Gray-white typo-h5">{summary}</p>;
    $[10] = summary;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== description) {
    t7 = <div className="whitespace-pre-line break-keep text-left font-500 text-Gray-white typo-body2 [&_p]:!text-Gray-white [&_span]:!text-Gray-white" dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[12] = description;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex grow-[3] flex-col gap-16 pl-120">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <div className={t1}><div className="my-auto size-full gap-40 flex-center content-container">{t4}{t5}{t8}</div></div>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = backgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("aspect-[500/346] w-full object-cover", "hidden mobile-tablet:block");
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <Image src={t10} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={850} height={588} preload={true} className={t11} />;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = pcBackgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("aspect-[1920/456] w-full object-cover", "mobile-tablet:hidden");
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <Image src={t13} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={1920} height={456} preload={true} className={t14} />;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className={cn("absolute inset-0 bg-Gray-black/30 bg-gradient-to-b from-transparent from-50% to-Gray-black/60", "mobile-tablet:hidden")} />;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== isKakaobank || $[28] !== logoUrl || $[29] !== title) {
    t17 = isKakaobank ? <div className={cn("absolute inset-0 hidden items-end gap-8 bg-gradient-to-b from-transparent from-50% to-Gray-black/50 px-32 pb-32", "mobile-tablet:flex")}><Image src={logoUrl} alt={title} width={56} height={56} className="size-56 shrink-0 rounded-pill border-1 border-Gray-black/5 object-cover shadow-[4px_0_7px_0_rgba(0,0,0,0.3)]" /><h1 className="break-keep pb-8 font-700 text-Gray-white typo-h5">{title}</h1></div> : <Image src={logoUrl} alt={title} width={72} height={72} className={cn("absolute bottom-0 left-20 hidden translate-y-1/2 rounded-pill object-cover shadow-lg", "mobile-tablet:block")} />;
    $[27] = isKakaobank;
    $[28] = logoUrl;
    $[29] = title;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t12 || $[32] !== t15 || $[33] !== t17 || $[34] !== t9) {
    t18 = <div className="relative">{t9}{t12}{t15}{t16}{t17}</div>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t17;
    $[34] = t9;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== description || $[37] !== isKakaobank || $[38] !== summary || $[39] !== title) {
    t19 = isKakaobank ? null : <div className={cn("hidden px-20 pt-48", "mobile-tablet:block")}><h1 className="mb-4 font-700 text-Gray-black typo-h6">{title}</h1><p className="mb-16 whitespace-pre-line font-500 text-Gray-700 typo-body3">{summary}</p><p className="text-Gray-600 typo-body3 [&_p]:!text-Gray-600 [&_p]:!typo-body4 [&_span]:!text-Gray-600 [&_span]:!typo-body4" dangerouslySetInnerHTML={{
        __html: description
      }} /></div>;
    $[36] = description;
    $[37] = isKakaobank;
    $[38] = summary;
    $[39] = title;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== institutionId || $[42] !== isKakaobank) {
    t20 = isKakaobank ? null : <div className={cn("mt-32 px-40 content-container", "mobile-tablet:px-20")}><Suspense fallback={<div className={cn("aspect-[1200/180] w-full rounded-medium bg-Gray-50", "mobile-tablet:aspect-[335/124]")} />}><BenefitsBanner institutionId={institutionId} /></Suspense></div>;
    $[41] = institutionId;
    $[42] = isKakaobank;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t18 || $[45] !== t19 || $[46] !== t20) {
    t21 = <section>{t18}{t19}{t20}</section>;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  return t21;
};